module.exports = __webpack_public_path__ + "static/media/img-header.a426ece1.jpg";